var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-list-item"},[_c('img',{attrs:{"src":_vm.project.image,"alt":""}}),_c('p',[_vm._v(_vm._s(_vm.project.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }